import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import LogInModal from 'flarum/forum/components/LogInModal';
import CreateGroupModal from './CreateGroupModal';
export default class AboutPage extends Page {

  view() {
    const baseUrl = app.forum.attribute('baseUrl') || '';
    return (
      <div className="AboutPage">
        {/* 顶部珊瑚色横幅 */}
        <div className="AboutPage-banner">
          <div className="AboutPage-banner-content">
            <p className="AboutPage-banner-text">
              Welcome to our interactive community section, a platform where expatriates can freely engage and enjoy their lives in Shanghai.
            </p>
          </div>
        </div>

        {/* 中间白色背景部分 */}
        <div className="AboutPage-content">
          <div className="AboutPage-content-wrapper">
            {/* 左侧：积分说明 */}
            <img src={baseUrl + '/assets/images/group.png'} alt="Points" class="AboutPage-points-image" />

            {/* 右侧：社区探索说明 */}
            <div className="AboutPage-right-section">
              <p className="AboutPage-explore-text">
                As our users, you can explore various community groups, choose your favorites, and participate in discussions. Feel free to ask questions, share experiences, and sign up for events.
              </p>
            </div>
          </div>
        </div>
        <div className="AboutPage-content  bg-gray">
        <div className="AboutPage-content-wrapper">
        <div className="AboutPage-left-section">
              <p className="AboutPage-points-text">
                Earn points by posting, liking, commenting, and sharing content, then redeem them for exciting rewards.
              </p>
              <div className="AboutPage-icons">
                <div className="AboutPage-icon-item">
                  <div className="AboutPage-icon-circle">
                    <i className="fa-light fa-paper-plane"></i>
                  </div>
                  <span className="AboutPage-icon-label">Post</span>
                </div>
                <div className="AboutPage-icon-item">
                  <div className="AboutPage-icon-circle">
                    <i className="fa-light fa-thumbs-up"></i>
                  </div>
                  <span className="AboutPage-icon-label">Like</span>
                </div>
                <div className="AboutPage-icon-item">
                  <div className="AboutPage-icon-circle">
                    <i className="fa-light fa-comment"></i>
                  </div>
                  <span className="AboutPage-icon-label">Comment</span>
                </div>
                <div className="AboutPage-icon-item">
                  <div className="AboutPage-icon-circle">
                    <i className="fa-light fa-share"></i>
                  </div>
                  <span className="AboutPage-icon-label">Share</span>
                </div>
              </div>
            </div>
            </div>
            </div>
        {/* 底部：社区领袖邀请 */}
        <div className="AboutPage-leader-section">
          <img src={baseUrl + '/assets/images/about.png'} alt="Leader" class="AboutPage-leader-image" />
          <div className="AboutPage-leader-content">
            <p className="AboutPage-leader-text">
              We also warmly invite you to become a <span className="AboutPage-leader-highlight">Community Leader</span>.
            </p>
            <p className="AboutPage-leader-description">
              Create and manage your own group based on your interests, and we'll help raise awareness and attract like-minded people to share your passion and ambition
            </p>
            <Button 
              className="Button Button--primary AboutPage-apply-button"
              onclick={() => {
                //未登录跳转登录，登录了打开申请群组表单
                if (!app.session.user) {
                  app.modal.show(LogInModal);
                } else {
                  app.modal.show(CreateGroupModal);
                }
              }}
            >
              Apply to join
            </Button>
          </div>
        </div>
      </div>
    );
  }

  title() {
    return 'About';
  }
}

